import {ClassificationGroupObject} from 'api/task/types';

export enum GroupVariant {
  Default = 'default',
  Empty = 'empty',
}

/**
 * The props interface of a group component.
 * @param {GroupVariant | undefined} variant
 */
export interface GroupProps extends ClassificationGroupObject {

  /**
   * Theme variant of the group.
   * @type {GroupVariant | undefined}
   */
  variant?: GroupVariant;

}
